import { useMemo } from 'react';

function LeafSVG({ hue = 24 }: { hue?: number }) {
  const fill = `hsl(${hue}, 60%, 44%)`;
  const stroke = `hsl(${hue}, 60%, 28%)`;
  return (
    <svg viewBox="0 0 64 64" width="32" height="32">
      <defs>
        <linearGradient id="leafGrad" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stopColor={`hsl(${hue}, 70%, 62%)`} />
          <stop offset="100%" stopColor={fill} />
        </linearGradient>
      </defs>
      <path
        d="M8 40c18 12 34 8 44-8 2-4 4-10 2-14-3-6-12-8-22-2S9 30 8 40Z"
        fill="url(#leafGrad)"
        stroke={stroke}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path d="M12 42c8-6 18-10 28-24" stroke={stroke} strokeWidth="2" fill="none" />
    </svg>
  );
}

export default function Leaves({ intensity = 'med' }: { intensity?: string }) {
  const count = useMemo(() => (intensity === 'high' ? 60 : intensity === 'low' ? 22 : 36), [intensity]);

  const nodes = useMemo(
    () =>
      new Array(count).fill(0).map((_, i) => {
        const size = 18 + Math.random() * 18; // px
        const left = Math.random() * 100;
        const dur = 9 + Math.random() * 10;
        const delay = Math.random() * 6;
        const drift = (Math.random() * 120 - 60) + 'px';
        const spin = (360 + Math.random() * 540) + 'deg';
        const startRot = Math.floor(Math.random() * 360) + 'deg';
        const hue = [18, 24, 32, 36, 40][Math.floor(Math.random() * 5)]; // autumn tones

        return (
          <div
            key={i}
            className="leaf overlay-layer"
            style={{
              left: `${left}%`,
              width: size * 2,
              height: size * 2,
              animationDuration: `${dur}s, ${Math.max(6, dur - 2)}s, ${dur}s`,
              animationDelay: `${delay}s, ${delay}s, ${delay}s`,
              ['--drift' as string]: drift,
              ['--spin' as string]: spin,
              ['--start-rot' as string]: startRot,
            }}
          >
            <div style={{ transform: 'translate(-50%, -50%)' }}>
              <LeafSVG hue={hue} />
            </div>
          </div>
        );
      }),
    [count]
  );

  return <div className="overlay-root">{nodes}</div>;
}
